import { render, staticRenderFns } from "./sendingEtype.vue?vue&type=template&id=11d7bcc6&"
import script from "./sendingEtype.vue?vue&type=script&lang=js&"
export * from "./sendingEtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports